// extracted by mini-css-extract-plugin
export default {"background":"NewPassword_background__ta3-R"};